import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, ListGroup, Image, Card } from 'react-bootstrap';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { useGetOpeningStoreStockDetailsQuery } from '../slices/openingStoreStocksApiSlice';

const OpeningStoreStockScreen = () => {
  const { id: openingStoreStockId } = useParams();

  const { data: openingStoreStock, refetch, isLoading, error } = useGetOpeningStoreStockDetailsQuery(openingStoreStockId);

  useEffect(() => {
    if (!openingStoreStock) {
      refetch();
    }
  }, [openingStoreStock, refetch]);

  return isLoading ? (
    <Loader />
  ) : error ? (
    <Message variant="danger">{error?.data?.message || error.error}</Message>
  ) : (
    <>
      <h1>OpeningStoreStock {openingStoreStock?._id || 'N/A'}</h1>
      <Row>
        <Col md={8}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h2>Supplier Details</h2>
              <p>
                <strong>Name: </strong> {openingStoreStock?.supplierDetails?.name || 'N/A'}
              </p>
              <p>
                <strong>Company: </strong> {openingStoreStock?.supplierDetails?.company || 'N/A'}
              </p>
              <p>
                <strong>Phone: </strong> {openingStoreStock?.supplierDetails?.telephone || 'N/A'}
              </p>
              <p>
                <strong>Address: </strong> {openingStoreStock?.supplierDetails?.address || 'N/A'}
              </p>
              <p>
                <strong>Serial: </strong> {openingStoreStock?.supplierDetails?.serialNumber || 'N/A'}
              </p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>OpeningStoreStock Note</h2>
              <p>{openingStoreStock?.note || 'No additional notes provided'}</p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>OpeningStoreStock Items</h2>
              {openingStoreStock?.openingStoreStockItems?.length === 0 ? (
                <Message>This openingStoreStock has no items</Message>
              ) : (
                <ListGroup variant="flush">
                  {openingStoreStock?.openingStoreStockItems?.map((item, index) => (
                    <ListGroup.Item key={index}>
                      <Row>
                        <Col md={1}>
                          <Image
                            src={item?.images?.[0] || 'https://via.placeholder.com/40'}
                            alt={item?.name || 'Unnamed'}
                            fluid
                            rounded
                          />
                        </Col>
                        <Col>
                          <strong>{item?.name || 'Unnamed'}</strong>
                        </Col>
                        <Col md={4}>
                          {item?.qty || 0} x ${item?.price || 0} = $
                          {(item?.qty || 0) * (item?.price || 0)}
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={4}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <h2>OpeningStoreStock Summary</h2>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Date</Col>
                  <Col>{openingStoreStock?.date?.substring(0, 10) || 'N/A'}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Total</Col>
                  <Col>${openingStoreStock?.totalPrice || 0}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Status</Col>
                  <Col>{openingStoreStock?.status || 'N/A'}</Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default OpeningStoreStockScreen;